const rootElement = document.getElementById('root');
const resolveLocalUrl = (url) => {
    return url ? url.replace('replace-with-local-url', window.location.origin) : '';
};
// @ts-expect-error
function resolveApiRestUrl(external = process.env.API_REST_URL) {
    if (external) {
        return external;
    }
    if (rootElement) {
        return rootElement.getAttribute('data-api-rest-url') || '';
    }
    return '';
}
// @ts-expect-error
function resolveApiGraphQlUrl(external = process.env.API_GRAPHQL_URL) {
    if (external) {
        return external;
    }
    if (rootElement) {
        return rootElement.getAttribute('data-api-graphql-url') || '';
    }
    return '';
}
export const PUBLIC_URL = rootElement ? rootElement.getAttribute('data-public-url') || '' : '';
export const VERSION = rootElement ? rootElement.getAttribute('data-version') || '' : '';
export const API_REST_URL = resolveApiRestUrl();
export const API_GRAPHQL_URL = resolveApiGraphQlUrl();
export const WEBSITE_URL = rootElement ? rootElement.getAttribute('data-website-url') || '' : '';
const staticUrl = rootElement ? resolveLocalUrl(rootElement.getAttribute('data-static-url') || '') || '' : '';
export const STATIC_URL = staticUrl === '<!-- STATIC_URL -->' ? 'http://127.0.0.1:9001/codeac-static/' : staticUrl;
export const GOOGLE_ANALYTICS_ID = rootElement ? rootElement.getAttribute('data-google-analytics') || '' : '';
export const AMPLITUDE_KEY = rootElement ? rootElement.getAttribute('data-amplitude-key') || '' : '';
export const GA_WEBSITE = rootElement ? rootElement.getAttribute('data-ga-website') || '' : '';
export const SMARTLOOK_KEY = rootElement ? rootElement.getAttribute('data-smartlook-key') || '' : '';
export const SENTRY_DSN = rootElement ? rootElement.getAttribute('data-sentry-dsn') || '' : '';
export const STRIPE_PUBLISHABLE_KEY = rootElement ? rootElement.getAttribute('data-stripe-publishable-key') || '' : '';
export const APP_IDENTIFIER = rootElement ? rootElement.getAttribute('data-identifier') || '' : '';
export const IS_APP_CODEAC = APP_IDENTIFIER === 'codeac';
export const GHA_SLUG = rootElement ? rootElement.getAttribute('data-gha-slug') || '' : '';
export const VCS = rootElement ? parseInt(rootElement.getAttribute('data-vcs') || '') || null : null;
export const VCS_LINK = rootElement ? rootElement.getAttribute('data-vcs-link') || '' : '';
// AWS RUM
export const AWS_RUM_ID = rootElement ? rootElement.getAttribute('data-aws-rum-id') || '' : '';
export const AWS_RUM_REGION = rootElement ? rootElement.getAttribute('data-aws-rum-region') || '' : '';
export const AWS_IDENTITY_POOL_ID = rootElement ? rootElement.getAttribute('data-aws-identity-pool-id') || '' : '';
